import Head from "next/head";
import { wrapper } from "@/redux/Store";

import RecommendationSourcesPage from "@/containers/StaticPages/RecommendationSourcesPage";
const RecommendationPage = () => (
  <>
    <Head>
      <title>Shyft</title>
    </Head>
    <main>
      <RecommendationSourcesPage />
    </main>
  </>
);

export default RecommendationPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
